import io from 'socket.io-client'
import _ from 'lodash'
import immutable from 'immutable'
import moment from 'moment'

import {
    socketConnect,
    socketDisconnect,
    socketAuthenticate,
    socketInitializeTrip,
    socketLunaClone,
    socketLoadTrip,
    socketUpdate,
    socketRecvUpdate,
    socketReject,
    socketQueueCommand,
    SOCKET_UPDATE,
    SOCKET_REJECT
} from './socket.action'
import {StateChange} from './socket.statechange'
import presence from './socket.presence'
import chat from './socket.chat'
import {socketUtil} from './socket.util'
import {SOCKET_ROOM} from './socket.room'
import diffUtil from '../util/diff.util'
import jotUtil from '../util/jot.util'
import userUtil from '../util/user.util'


let socket = null


export const socketMiddleware = (store) => (next) => (action) => {
    if (socket && !_.isUndefined(action.realtime)) {
        let [params, message] = socketUtil.prepareAction(action)
        socket.emit(params.room, message)
    } else if (!socket && !_.isUndefined(action.realtime)) {
        // socket is not connected
    }

    let prevState = store.getState()
    let result = next(action)

    if (!action.ignoreJOTChange) {
        let jots, reverseJots
        let currentState = store.getState()

        if (_.isFunction(action.generateJOT)) {
            // let the action generate the forward/reverse jot
            let generatedJOT = action.generateJOT(prevState)
            jots = generatedJOT.forward
            reverseJots = generatedJOT.reverse
        } else {
            // automatically calculate the jots based on a state diff
            jots = StateChange.build(prevState, currentState)
            reverseJots = StateChange.build(currentState, prevState)
        }

        if (!_.isNull(jots)) {
            StateChange.dispatch(store, socket, jots, reverseJots, currentState.get('revision'), currentState.get('clientSessionId'))
        }
    }
    return result
}

export const connectSocket = (host, store) => {
    socket = io(`${host}`)

    let socketHandler = (data) => {
        if (_.has(data, 'realtime')) {
            delete data.realtime
        }

        if (data.type === SOCKET_UPDATE) {
            store.dispatch(
                socketRecvUpdate(
                    socket,
                    data.op,
                    data.revision,
                    data.author,
                    data.traveler_guid,
                    data.commit_message,
                    data.git_hash,
                    data.timestamp
                )
            )
        } else if (data.type === 'REJECT') {
            store.dispatch(
                socketReject(
                    socket,
                    data.op,
                    data.revision
                )
            )
        } else if (data.type && data.type === 'RESET') {
            // this is a special case and we need to sync documents beforehand so
            // we handle it specially here
            var state = store.getState().toJS()

            let newState = _.merge(state, data)
            var diff = diffUtil.diff(data.document, newState.document)

            if (diff) {
                // diff will sync our local with the server
                var op = jotUtil.fromDiff(diff)
                let reverseOp = jotUtil.toList([])

                store.dispatch(
                    socketQueueCommand(
                        socket,
                        op,
                        reverseOp,
                        data.revision,
                        data.clientSessionId
                    )
                )
            }

            // dispatch regular RESET event
            data.ignoreJOTChange = true
            store.dispatch(data)
        } else if (data.type) {
            data = socketUtil.deserialize(data)
            data.ignoreJOTChange = true
            store.dispatch(data)
        }
    }

    let authHandler = (data) => {
        presence.listen(store, socket)
        chat.listen(store, socket)

        let name = `${window.payload.traveler.firstname} ${window.payload.traveler.lastname}`
        if (_.trim(name) === '') {
            name = window.payload.traveler.email
        }


        if (window.payload.action === 'INITIALIZE') {
            store.dispatch(
                socketInitializeTrip(
                    window.payload.trip.guid,
                    window.payload.itinerary.guid,
                    window.payload.trip.name,
                    window.payload.travelers,
                    window.payload.travelerGuid,
                    name
                )
            )
        } else if (window.payload.action === 'LUNACLONE') {
            store.dispatch(
                socketLunaClone(
                    window.payload.trip.guid,
                    window.payload.itinerary.guid,
                    window.payload.cloned_trip_guid,
                    window.payload.cloned_itinerary_guid,
                    window.payload.trip.name,
                    window.payload.travelers,
                    window.payload.travelerGuid,
                    name
                )
            )
        } else {
            store.dispatch(
                socketLoadTrip(
                    window.payload.trip.guid,
                    window.payload.itinerary.guid,
                    window.payload.travelerGuid,
                    name
                )
            )
        }
    }

    socket.on('connect', () => {
        store.dispatch(socketConnect())
        // sends authenticate to server, we listen on authenticated room, then
        // if we get a response, we send up INITIALIZE_TRIP payload
        store.dispatch(socketAuthenticate(window.payload.travelerGuid))
    })

    socket.on('disconnect', (data) => {
        store.dispatch(socketDisconnect())
    })

    socket.on(SOCKET_ROOM.PLANNER, socketHandler)
    socket.on(SOCKET_ROOM.AUTHENTICATED, authHandler)
}
